import { getRecaptchaResult } from 'components/recaptcha_widget/component'

$('.registration-form-submit').on('click', async function(e) {
  e.preventDefault();
  let result = await getRecaptchaResult() // always run recaptcha *after* validation

  if (result) {
    $('.registration-form').submit();
  }
})
